import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogClose,
} from "@/components/ui/dialog";
import { useState } from "react";
import { Button } from "@/components/ui/button";

import { useGetSpecificProfileQuery } from "@/redux/features/api/profile/profileApiSlice";
import Loader from "@/components/shared/Loader";
import MyLink from "@/components/shared/myLink/MyLink";
import FreeConsultationForm from "./Form/OtherServicesForm";
import { useTranslate } from "@/components/base/providers/TranslateProv";

const OtherServicesData = ({
  otherServices,
  selectedIds,
  children,
}: {
  otherServices: any;
  selectedIds: any;
  children: any;
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data, isLoading, error } = useGetSpecificProfileQuery({});

  const { locale } = useTranslate();

  const handleButtonClick = () => {
    if (selectedIds && selectedIds.length > 0) {
      setIsModalOpen(true);
    } else {
      alert(
        locale === "ar"
          ? "يرجى اختيار خدمة أولا"
          : "Please select a service first"
      );
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="bg-primaryColor/10 text-primaryColor flex items-center justify-center rounded-[10px] h-[50px] w-full animate-pulse">
          {locale === "ar" ? "جاري التحميل..." : "Loading..."}
        </div>
      ) : error ? (
        <MyLink
          className="  bg-primaryColor text-16 text-white font-[500] flex items-center justify-center rounded-[10px] h-[50px] w-full"
          href="/login"
        >
          {locale === "ar" ? "سجل دخول اولا" : "Login First"}
        </MyLink>
      ) : (
        <>
          <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
            <DialogTrigger asChild>{children}</DialogTrigger>
            <DialogContent
              locale={locale}
              className="mx-auto w-[95vw] md:w-fit max-w-[95vw] h-auto p-6"
            >
              <DialogHeader>
                <DialogTitle className="text-center text-lg md:text-xl w-full">
                  {locale === "ar"
                    ? " معلومات ستفيدنا للرد عليك وتجهيز لك ما تحتاجه"
                    : "Information to help us respond to you and provide what you need"}
                </DialogTitle>
              </DialogHeader>

              {isLoading ? (
                <Loader />
              ) : (
                <>
                  {/* form */}
                  <FreeConsultationForm
                    selectedIds={selectedIds}
                    otherServices={otherServices}
                    data={data?.data}
                  />
                </>
              )}
            </DialogContent>
          </Dialog>
        </>
      )}
    </>
  );
};

export default OtherServicesData;
